import { ContentState, Editor, EditorState, convertFromRaw } from "draft-js";

const DraftViewer = ({ content }) => {
  // Convert the raw content to EditorState
  const getEditorState = (content) => {
    if (!content) return EditorState.createEmpty();
    try {
      const contentState = convertFromRaw(JSON.parse(content));
      return EditorState.createWithContent(contentState);
    } catch (error) {
      // Plain text fallback — content was not stored as DraftJS JSON
      return EditorState.createWithContent(ContentState.createFromText(content));
    }
  };

  const editorState = getEditorState(content);

  // Media component for rendering images
  const MediaComponent = (props) => {
    const entity = props.contentState.getEntity(props.block.getEntityAt(0));
    const { src } = entity.getData();

    return (
      <div className="media-block">
        <img src={src} alt="Embedded media" style={{ maxWidth: "100%" }} />
      </div>
    );
  };

  // Custom block renderer for handling images
  const blockRendererFn = (block) => {
    if (block.getType() === "atomic") {
      return {
        component: MediaComponent,
        editable: false,
      };
    }
    return null;
  };

  return (
    <Editor
      editorState={editorState}
      readOnly
      blockRendererFn={blockRendererFn}
    />
  );
};

export default DraftViewer;
